import { type CarrierInstructionCostReference, carrierInstructionCostKey } from "~/shared/documents/carrier-instruction-costs";

export const changeCarrierInstructionCostSelection = (
  selection: CarrierInstructionCostReference[],
  reference: CarrierInstructionCostReference,
  checked: boolean,
): CarrierInstructionCostReference[] => {
  const remaining = selection.filter(selected => carrierInstructionCostKey(selected) !== carrierInstructionCostKey(reference));
  return checked ? [...remaining, { sourceType: reference.sourceType, costId: reference.costId }] : remaining;
};
